import { AppBar, Toolbar, Typography, Button, Box, IconButton, useTheme } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import LogoutIcon from '@mui/icons-material/Logout';
import { useColorMode } from '../ThemeContext';
import { useAuth } from '../context/AuthContext';

function Header(): React.JSX.Element {
  const location = useLocation();
  const theme = useTheme();
  const colorMode = useColorMode();
  const { logout } = useAuth();

  return (
    <AppBar position="static">
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Right Side: Title and Navigation */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '15px' }}>
            <Typography fontSize={'10px'} letterSpacing={'2px'} sx={{ opacity: '0.7' }}>דולפינים במים</Typography>
            <Typography variant="h6" component="div" sx={{ lineHeight: 1.2 }}>
              פאנל ניהול
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              color="inherit"
              component={Link}
              to="/"
              sx={{
                textDecoration: location.pathname === '/' ? 'underline' : 'none',
                fontWeight: location.pathname === '/' ? 'bold' : 'normal'
              }}
            >
              קבוצות
            </Button>
            <Button
              color="inherit"
              component={Link}
              to="/contacts"
              sx={{
                textDecoration: location.pathname === '/contacts' ? 'underline' : 'none',
                fontWeight: location.pathname === '/contacts' ? 'bold' : 'normal'
              }}
            >
              אנשי קשר
            </Button>
            <Button
              color="inherit"
              component={Link}
              to="/all-variants"
              sx={{
                textDecoration: location.pathname === '/all-variants' ? 'underline' : 'none',
                fontWeight: location.pathname === '/all-variants' ? 'bold' : 'normal'
              }}
            >
              קורסים
            </Button>
            <Button
              color="inherit"
              component={Link}
              to="/all-purchases"
              sx={{
                textDecoration: location.pathname === '/all-purchases' ? 'underline' : 'none',
                fontWeight: location.pathname === '/all-purchases' ? 'bold' : 'normal'
              }}
            >
              הזמנות
            </Button>
          </Box>
        </Box>

        {/* Left Side: Logout and Theme */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button

            color="inherit"
            component={Link}
            to="https://app.greeninvoice.co.il/lobby"
            target='_blank'
            sx={{
              textDecoration: location.pathname === '/' ? 'underline' : 'none',
              fontWeight: location.pathname === '/' ? 'bold' : 'normal',
              color: 'lightgreen'
            }}
          >
            מורנינג
          </Button>
          <IconButton onClick={colorMode.toggleColorMode} color="inherit" title="החלף מצב">
            {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
          <IconButton onClick={logout} color="inherit" title="התנתק">
            <LogoutIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header; 